"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Tooltip = function (_a) {
    var children = _a.children, isHidden = _a.isHidden, className = _a.className, style = _a.style, triggerRef = _a.triggerRef;
    var tooltipRef = react_1.useRef(null);
    var positionTooltip = function () {
        if (!triggerRef.current || !tooltipRef.current)
            return;
        var parentCoords = triggerRef.current.getBoundingClientRect();
        var tooltipCoords = tooltipRef.current.getBoundingClientRect();
        var isTooltipBottomVisible = (parentCoords.bottom + tooltipCoords.height) <= (window.innerHeight || document.documentElement.clientHeight);
        var isTooltipRightVisible = (parentCoords.right + tooltipCoords.width / 2) <= (window.innerWidth || document.documentElement.clientWidth);
        if (!isTooltipBottomVisible && !isTooltipRightVisible) {
            tooltipRef.current.style.top = parentCoords.top - tooltipCoords.height + "px";
            tooltipRef.current.style.right = '0';
            tooltipRef.current.style.left = 'initial';
        }
        else if (!isTooltipBottomVisible && isTooltipRightVisible) {
            tooltipRef.current.style.top = parentCoords.top - parentCoords.height + "px";
            tooltipRef.current.style.left = parentCoords.left + "px";
        }
        else if (isTooltipBottomVisible && !isTooltipRightVisible) {
            tooltipRef.current.style.top = parentCoords.top + parentCoords.height + "px";
            tooltipRef.current.style.right = '0';
            tooltipRef.current.style.left = 'initial';
        }
        else {
            tooltipRef.current.style.top = parentCoords.top + parentCoords.height + "px";
            tooltipRef.current.style.left = parentCoords.left + "px";
        }
        tooltipRef.current.style.visibility = 'visible';
        tooltipRef.current.style.opacity = '1';
    };
    react_1.useEffect(function () {
        if (tooltipRef.current)
            positionTooltip();
    });
    if (isHidden)
        return null;
    return (react_1.default.createElement(styles_1.default, { ref: tooltipRef, className: className || '', style: style }, children));
};
exports.default = Tooltip;
//# sourceMappingURL=index.js.map